import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {useRouter} from 'next/router';
import {useProductRoutes} from 'core/modules/routing/hooks/useProductRoute';
import {useCallback} from 'react';
import {SPECIFICATIONS_SCROLL_NAME} from 'modules/product-card/constants';
import {Typography} from 'components/Typography';
import style from './style.module.scss';
import {ProductCharacteristicsList} from 'modules/product-card/components/ProductCharacteristicsList';
import {ProductCharacteristicsMoreButton} from 'modules/products/components/ProductCharacteristicsMoreButton';
import {Arrow} from 'components/icons/Arrow';
import cs from 'classnames';

interface IProductCharacteristicsProps {
    className?: string;
}

export const ProductCharacteristics = ({className}: IProductCharacteristicsProps) => {
    const {code} = useAppSelector(selectProductData) || {};

    const {push} = useRouter();
    const {
        product: {url},
    } = useProductRoutes();

    const handleSeeAllInfo = useCallback(() => {
        if (code) {
            push(`${url({id: code})}#${SPECIFICATIONS_SCROLL_NAME}`);
        }
    }, [code, push, url]);

    return (
        <div className={cs(style.container, className)}>
            <Typography className={style.title} variant={'h2-custom-regular'}>
                О товаре
            </Typography>
            <ProductCharacteristicsList
                moreLink={
                    <ProductCharacteristicsMoreButton
                        icon={<Arrow direction={'right'} size={'sm'} />}
                        onClick={handleSeeAllInfo}
                        text={'Подробнее о товаре'}
                    />
                }
            />
        </div>
    );
};
